export default __webpack_public_path__ + "static/media/img-ovato-symbol-new.a8006ec6.jpg";